import React from "react";
import { Link } from "react-router-dom";
import type { BlogCategory } from "@/types/blog";
import { useLanguageContext } from "@/hooks";

type BlogCategoryPillsProps = {
  categories: BlogCategory[];
  activeCategorySlug?: string;
};

export const BlogCategoryPills: React.FC<BlogCategoryPillsProps> = ({
  categories,
  activeCategorySlug,
}) => {
  const { language } = useLanguageContext();

  return (
    <div className="d-flex flex-wrap gap-2">
      <Link
        to="/blog"
        className={`btn btn-sm ${!activeCategorySlug ? "kg-btn kg-btn-success" : "btn-outline-secondary"}`}
      >
        {language("label.all") || "All"}
      </Link>
      {categories.map((category) => (
        <Link
          to={`/blog/${category.categorySlug}`}
          className={`btn btn-sm ${
            activeCategorySlug === category.categorySlug ? "kg-btn kg-btn-success" : "btn-outline-secondary"
          }`}
          key={category.categorySlug}
        >
          {category.categoryName}
        </Link>
      ))}
    </div>
  );
};

export default BlogCategoryPills;
